import { Button, ErrorContainer } from 'components';
import { useFormikContext } from 'formik';
import { isAiScribeRecordingStatus, openAiScribeDrawer } from 'store/aiScribe/aiScribeSlice';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { hideNoteModal } from 'store/noteModal/noteModalSlice';
import { notifyUserError } from 'utils/notifications';

import { useNoteFormContext } from '../context/noteFormContext';
import { NoteFormValues, remapValues, removeEmptyFieldsFromObject } from '../utils';

export const AiScribeButton = () => {
  const aiScribe = useAppSelector((state) => state.aiScribe);
  const dispatch = useAppDispatch();
  const { clientName, prependedClientId, clientId, onOpenAiScribeDrawer } = useNoteFormContext();
  const formik = useFormikContext<NoteFormValues>();

  const onRecord = () => {
    if (isAiScribeRecordingStatus(aiScribe.status)) {
      notifyUserError('There is already a recording in progress');
      return;
    }
    dispatch(
      openAiScribeDrawer({
        clientId: Number(clientId),
        clientName: clientName,
        prependedClientId: prependedClientId,
        note: removeEmptyFieldsFromObject(remapValues({ values: formik.values }))
      })
    );
    dispatch(hideNoteModal());

    onOpenAiScribeDrawer?.();
  };

  return (
    <>
      <Button
        text="Record"
        theme="primary"
        icon={<span className="material-icons">mic</span>}
        handleOnClick={onRecord}
        type="button"
      />
      <ErrorContainer
        errors={formik.errors}
        visible={formik.touched?.note && formik.errors?.note}
        name="test"
      />
    </>
  );
};
